
import { defineComponent } from 'vue';
import Customer from '@/types/Customer';
import FbxButton from '@/components/fbx-button.vue';
import { mapGetters } from 'vuex';
import { getDirectContactTitle } from '@/shared/helpers';
import { ActionTypes } from '@/store/actionTypes';
import DriverMetrics, {
    DriverDetails,
    DriverGeolocation,
    LocationSource,
    MetricsType,
} from '@/types/DriverMetrics';
import Address from '@/types/Address';
import locationReverseGeocode from '@/libraries/heremaps/reverseGeocode';
import { MutationTypes } from '@/store/mutationTypes';
import FbaApiError from '@/types/FbaApiError';

export default defineComponent({
    name: 'NoTrailersAvailable',
    components: {
        FbxButton,
    },
    props: {
        listView: String,
    },
    computed: {
        ...mapGetters({
            driver: 'getDriver',
            deviceInfo: 'getDeviceInfo',
            bestAvailableLocation: 'getPinnedBestAvailableLocation',
        }),
        customerAtCurrentLocation(): Customer | null | undefined {
            return this.$store.getters.getCustomerAtCurrentLocation;
        },
        messageText(): string {
            if (this.customerAtCurrentLocation instanceof Customer) {
                return `You are at ${this.customerAtCurrentLocation?.name}`;
            } else {
                return ``;
            }
        },
        contact() {
            return getDirectContactTitle(this.driver.company, true);
        },
    },
    methods: {
        findTrailers(): void {
            this.$router.push({ name: 'FindTrailer' });
        },
    },
    async created() {
        const address = new Address('', '', '', '', '', '', '');
        const geocode = await locationReverseGeocode(
            this.bestAvailableLocation
        );

        if (geocode instanceof FbaApiError) {
            this.$store.commit(MutationTypes.SET_ERROR, geocode as FbaApiError);
        } else {
            address.line1 = geocode.line1 ?? '';
            address.line2 = geocode.line2 ?? '';
            address.city = geocode.city ?? '';
            address.state = geocode.state ?? '';
            address.zip = geocode.zip ?? '';
            address.country = geocode.country ?? '';
        }

        const locationSource = this.deviceInfo.isGeoLocationShared
            ? LocationSource.DEVICE_GPS
            : LocationSource.TRUCK;

        const metrics = new DriverMetrics(
            MetricsType.NO_TRAILERS,
            new DriverGeolocation(
                this.bestAvailableLocation.lat,
                this.bestAvailableLocation.lng,
                locationSource
            ),
            address,
            new DriverDetails(
                this.driver.driverCode,
                this.driver.truckCode,
                this.driver.company
            )
        );
        await this.$store.dispatch(ActionTypes.POST_DRIVER_METRICS, metrics);
    },
});
